// extracted by mini-css-extract-plugin
export default {"title":"TitleCard_title__aewdT"};